import { createBoxComponents } from '../setup-factories'

export const { BoxMarginBottom50px, BoxMarginBottom30px, BoxMarginBottom20px, BoxMarginBottom10px } =
  createBoxComponents(
    { display: 'block' },
    {
      MarginBottom50px: {
        margin: { bottom: '50px' }
      },
      MarginBottom30px: {
        margin: { bottom: '30px' }
      },
      MarginBottom20px: {
        margin: { bottom: '20px' }
      },
      MarginBottom10px: {
        margin: { bottom: '10px' }
      }
    }
  )
